module.exports = __webpack_public_path__ + "static/media/WXRWYR4.3b3eade3.png";